import React from 'react';

import {MinimalExpirationInfo} from 'constants/SampleStatusConstants';
import TextValue from 'ui-library/TextValue';
import {readableTime} from 'util/DateUtil';

interface ExpirationDateCellInfo extends Omit<MinimalExpirationInfo, 'isExpired'> {
  isExpired?: boolean;
}

export default function ExpirationDateCell({
  expirationInfo,
}: {
  expirationInfo?: ExpirationDateCellInfo;
}): JSX.Element {
  return (
    <TextValue
      value={
        expirationInfo?.isTrackingEnabled && expirationInfo?.expirationDate != null
          ? readableTime(expirationInfo.expirationDate, {showTime: true})
          : null
      }
      placeholder={expirationInfo?.isTrackingEnabled ? 'Not specified' : 'N/A'}
    />
  );
}
